/* Emerald V3 — Header mega-menu hover-to-open (Seed-style)
 * The Ivy/Dawn header uses <details>/<summary> click-to-open. We add
 * hover-to-open on devices with a real cursor while keeping the click
 * fallback intact for keyboard and touch.
 *
 * Loaded globally from layout/theme.liquid. Idempotent.
 */
(function () {
  if (window.__emv3Nav) return; window.__emv3Nav = true;

  // Skip on touch / no-hover devices — they rely on click-to-open.
  if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.id && e.target.id.indexOf('shopify-section-header') === 0) {
      wire();
    }
  });

  function wire () {
    // Cover both header-menu types: mega ('details.mega-menu') AND
    // dropdown (plain '<details>' inside header-menu / inline menu).
    var menus = document.querySelectorAll(
      '.header-wrapper header-menu > details, ' +
      '.header-wrapper .header__inline-menu > ul > li > header-menu > details, ' +
      '.header-wrapper .header__inline-menu details.mega-menu'
    );
    if (!menus.length) return;

    var openTimer, closeTimer;
    var current = null;

    menus.forEach(function (details) {
      if (details.__emv3NavBound) return;
      details.__emv3NavBound = true;

      var li = details.closest('li') || details.parentElement;
      if (!li) return;
      var panel = details.querySelector('.mega-menu__content, .header__submenu');

      function scheduleClose () {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          // Don't close if cursor is still over the trigger or the panel.
          if (li.matches(':hover') || (panel && panel.matches(':hover'))) return;
          details.removeAttribute('open');
          if (current === details) current = null;
        }, 450);
      }
      function cancelClose () { clearTimeout(closeTimer); }

      li.addEventListener('mouseenter', function () {
        cancelClose();
        clearTimeout(openTimer);
        if (current && current !== details) current.removeAttribute('open');
        openTimer = setTimeout(function () {
          details.setAttribute('open', '');
          current = details;
        }, 80);
      });
      li.addEventListener('mouseleave', scheduleClose);

      // Critical: bind on the panel itself so the menu stays open while
      // the cursor is anywhere over the panel — including the
      // invisible bridge zone (::before) that fills the visual gap.
      if (panel) {
        panel.addEventListener('mouseenter', cancelClose);
        panel.addEventListener('mouseleave', scheduleClose);
      }
    });

    // Close everything when the cursor leaves the header entirely.
    var header = document.querySelector('.header-wrapper, .header-wrapper');
    if (header && !header.__emv3NavLeaveBound) {
      header.__emv3NavLeaveBound = true;
      header.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        menus.forEach(function (m) { m.removeAttribute('open'); });
        current = null;
      });
    }

    // Esc closes any open menu.
    if (!document.__emv3NavEscBound) {
      document.__emv3NavEscBound = true;
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        menus.forEach(function (m) { m.removeAttribute('open'); });
        current = null;
      });
    }
  }
})();

/* ==============================================================
   Emerald V3 — Pillars carousel retrofit
   Transforms the existing .emv3-pillars markup into a horizontal
   auto-rotating carousel WITHOUT touching the section liquid file.
   Adds .emv3-pillars--cx class so the matching CSS retrofit kicks
   in, then injects prev/next arrows + per-pillar dots, binds
   click handlers and runs auto-rotation with hover-pause.
   Configuration via data-* attributes on the section element OR
   sensible defaults: 2 visible desktop / 1 mobile / autoplay on /
   5s rotation. Idempotent + arms on shopify:section:load.
============================================================== */
(function () {
  if (window.__emv3PillarsCx) return; window.__emv3PillarsCx = true;

  function init() {
    document.querySelectorAll('section.emv3-pillars').forEach(setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);

  function setup(root) {
    if (root.__emv3PillarsBound) return;
    root.__emv3PillarsBound = true;
    var rows = root.querySelector('.emv3-pillars__rows');
    if (!rows) return;
    var slides = Array.prototype.slice.call(rows.querySelectorAll('.emv3-pillars__row'));
    if (slides.length < 2) return;

    // Peek-style carousel: one slide fully shown + sliver of next.
    // Manual navigation only by default — preserves the per-pillar
    // animations / spotlight effect that auto-rotation would interrupt.
    var autoplay   = root.getAttribute('data-autoplay') === 'true';
    var autoplayMs = parseInt(root.getAttribute('data-autoplay-ms'), 10) || 6000;

    root.classList.add('emv3-pillars--cx');

    // Build nav strip (arrows + per-pillar dots).
    var nav = document.createElement('div');
    nav.className = 'emv3-pillars__nav';

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'emv3-pillars__arrow emv3-pillars__arrow--prev';
    prev.setAttribute('aria-label', 'Previous pillar');
    prev.innerHTML = '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><path d="M10 3 L4 8 L10 13" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var dots = document.createElement('div');
    dots.className = 'emv3-pillars__dots';
    dots.setAttribute('role', 'tablist');
    dots.setAttribute('aria-label', 'Pillar selector');
    var dotEls = slides.map(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'emv3-pillars__dot';
      b.setAttribute('role', 'tab');
      b.setAttribute('data-i', String(i));
      if (i === 0) b.setAttribute('data-active', '');
      b.innerHTML = '<span>Pillar ' + (i + 1) + '</span>';
      dots.appendChild(b);
      return b;
    });

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'emv3-pillars__arrow emv3-pillars__arrow--next';
    next.setAttribute('aria-label', 'Next pillar');
    next.innerHTML = '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><path d="M6 3 L12 8 L6 13" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    nav.appendChild(prev);
    nav.appendChild(dots);
    nav.appendChild(next);
    root.appendChild(nav);

    var current = 0;
    var autoTimer;

    function applyVisible() {
      // Peek layout: max index is the last slide (each step = one slide).
      var max = Math.max(0, slides.length - 1);
      if (current > max) current = max;
      go(current);
    }
    function go(i) {
      var max = Math.max(0, slides.length - 1);
      current = Math.max(0, Math.min(i, max));
      var anchor = slides[current];
      var off = anchor ? anchor.offsetLeft - rows.offsetLeft : 0;
      slides.forEach(function (s) { s.style.transform = 'translateX(' + (-off) + 'px)'; });
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
      dotEls.forEach(function (d, idx) {
        if (idx === current) { d.setAttribute('data-active', ''); d.setAttribute('aria-selected', 'true'); }
        else { d.removeAttribute('data-active'); d.setAttribute('aria-selected', 'false'); }
      });
      prev.disabled = current === 0;
      next.disabled = current >= max;
    }
    function step(dir) {
      var max = Math.max(0, slides.length - 1);
      var t = current + dir;
      if (t > max) t = 0;
      if (t < 0) t = max;
      go(t);
    }
    next.addEventListener('click', function () { step(1); restartAuto(); });
    prev.addEventListener('click', function () { step(-1); restartAuto(); });
    dotEls.forEach(function (d) {
      d.addEventListener('click', function () {
        go(parseInt(d.getAttribute('data-i'), 10) || 0);
        restartAuto();
      });
    });

    function startAuto() {
      if (!autoplay) return;
      if (slides.length <= 1) return;
      stopAuto();
      autoTimer = setInterval(function () { step(1); }, autoplayMs);
    }
    function stopAuto() { if (autoTimer) { clearInterval(autoTimer); autoTimer = null; } }
    function restartAuto() { stopAuto(); startAuto(); }

    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', startAuto);
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(applyVisible, 150);
    });

    applyVisible();
    startAuto();
  }
})();
